module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/military-school-lvl2-100.adc2622a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/military-school-lvl2-100.png
// module id = 3546
// module chunks = 11